function applyDecoratorsDoNotUseInNewCodeDoNotUseInNewCode(...decorators) {
    // Call rightmost decorator first.
    const reversedDecorators = decorators.reverse();

    return (args) => {
        let transformedArgs = args;
        for(const decorator of reversedDecorators) {
            const nextArgs = decorator(transformedArgs);
            if(nextArgs) {
                transformedArgs = nextArgs;
            }
        }
        return transformedArgs;
    };
}

export default applyDecoratorsDoNotUseInNewCodeDoNotUseInNewCode;
